import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import {
  updateSingleDayShift,
  updateSpecificDay,
} from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { TDay, TSingleDayShift } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { SHIFT_TYPE } from 'models/Shift'
import { FormikProps } from 'formik'

export const handlePayRateChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<IScheduleSectionFormValues>,
  day: TSingleDayShift | TDay
) => {
  const {
    values: { days, type, single_day_shifts },
    setFieldValue,
  } = formik
  const { id } = day

  if (type === SHIFT_TYPE.SINGLEDAY) {
    setFieldValue(
      'single_day_shifts',
      updateSingleDayShift(single_day_shifts, String(id), {
        pay_value: e.target.value,
      })
    )
  }

  if (type === SHIFT_TYPE.MULTIDAY) {
    const updatedDays = updateSpecificDay(days, Number(id), {
      pay_value: e.target.value,
      is_dirty: true,
    })

    setFieldValue('days', updatedDays)
  }
}
